import { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";

export default function ChatInput({ onSend, disabled }) {
  const [value, setValue] = useState("");

  const handleSend = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        p: 2,
        borderTop: 1,
        borderColor: "divider",
        bgcolor: "background.default",
      }}
    >
      <TextField
        fullWidth
        size="small"
        placeholder="Ask Susie a question..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        multiline
        maxRows={3}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "999px",
            fontFamily: "'PT Serif', Georgia, serif",
            fontSize: 18,
          },
        }}
      />
      <IconButton
        onClick={handleSend}
        disabled={disabled || !value.trim()}
        sx={{
          bgcolor: "primary.main",
          color: "primary.contrastText",
          width: 48,
          height: 48,
          "&:hover": { bgcolor: "primary.main", opacity: 0.85 },
          "&.Mui-disabled": { bgcolor: "divider", color: "text.disabled" },
        }}
      >
        <SendIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
